<template>
  <div class="part-apply" id="partApply">
    <el-tabs type="card" @tab-click="handleClick">
      <el-tab-pane class="tabPane" label="售后申请"></el-tab-pane>
      <el-tab-pane class="tabPane" label="申请记录"></el-tab-pane>
    </el-tabs>
    <div v-if="tabType == 0">
      <div class="after-content" v-loading="loading">
        <div class="infobox" v-for="(ulItem, ulIndex) in orderList" :key="ulIndex">
          <div class="header">
            <span class="time">下单时间: {{ ulItem.orderContracts[0].orderItemDtoList[0].createdAt }}</span>
            <span class="id"
              >订单编号:
              {{ ulItem.orderContracts[0].orderItemDtoList[0].orderId }}
            </span>
          </div>
          <div v-for="(liItem, liIndex) in ulItem.orderContracts" :key="liIndex">
            <div v-for="(attr, attrIndex) in liItem.orderItemDtoList" :key="attrIndex">
              <div class="order">
                <div class="content">
                  <!-- <div class="tips">该商品已超过售后期</div> -->
                  <div
                    class="tips"
                    v-if="
                      [7, 8, 9, 10, -2].indexOf(attr.status) > -1 ||
                      ([2, 5].indexOf(attr.status) === -1 && attr.itemType === '1') ||
                      ([2, 5].indexOf(attr.status) === -1 && attr.itemType === '2') ||
                      ([2, 5].indexOf(attr.status) === -1 && attr.itemType === 1) ||
                      ([2, 5].indexOf(attr.status) === -1 && attr.itemType === 2)
                    "
                  >
                    {{
                      [7, 8, 9, 10].indexOf(attr.status) > -1
                        ? '该商品已申请过售后服务'
                        : ([2, 5].indexOf(attr.status) === -1 && attr.itemType === '1') ||
                          ([2, 5].indexOf(attr.status) === -1 && attr.itemType === '2') ||
                          ([2, 5].indexOf(attr.status) === -1 && attr.itemType === 1) ||
                          ([2, 5].indexOf(attr.status) === -1 && attr.itemType === 2)
                        ? '该商品无法申请售后服务'
                        : attr.status === -2 || attr.status === '-2'
                        ? '该商品已超过售后期'
                        : ''
                    }}
                  </div>
                  <div class="tips" v-if="attr.status == 4">该商品未确认收货</div>
                  <div class="height">
                    <div class="left">
                      <div class="img-container">
                        <img :src="attr.itemImage" alt="" class="img-con" />
                      </div>
                      <div class="message">
                        <h3 class="tit">
                          <span
                            v-if="attr.extraMap && attr.extraMap.activity && attr.extraMap.activity.tag"
                            class="activityTag"
                            >{{ attr.extraMap.activity.tag }}</span
                          >
                          <span v-if="attr.extraMap && attr.extraMap.bofogPurchase" class="activityTag">赠品</span>
                          <span v-if="attr.extraMap && attr.extraMap.collocationPurchase" class="activityTag"
                            >搭配购</span
                          >
                          <img
                            class="prizeTab"
                            style="width: 42px; height: 21px; margin: 0"
                            v-if="
                              (attr.extraMap && attr.extraMap.orderChannel === '3') ||
                              (attr.extraMap && attr.extraMap.orderChannel === 3)
                            "
                            src="@/assets/images/activity/lottery/prize.png"
                          />
                          {{ attr.itemName }}
                          <span class="hide">{{ attr.skuName }}</span>
                        </h3>
                        <div class="sku" v-if="attr.attributeMaps.length > 0 && attr.attributeMaps[0]">
                          <span style="marginright: 10px" v-for="(item, index) in attr.attributeMaps" :key="index">
                            {{ item.attrKey ? item.attrKey + ':' + item.attrVal : '' }}
                          </span>
                        </div>
                        <div class="number">
                          <span class="price">价格: {{ Number(attr.skuPrice) | currency('￥', 2) }}</span>
                          <span>数量：x{{ attr.quantity }}</span>
                        </div>
                        <!-- <p class="des"> -->
                        <!-- v-if="goodsList.itemType === '0' || goodsList.itemType === 0" -->
                        <!-- 整车才有经销商 -->
                        <span class="dealerWrap" v-if="attr.itemType === 0 || attr.itemType === '0'">
                          <span v-if="attr.extraMap && attr.extraMap.dealer">
                            <span>经销商:</span>
                            <span class="attr-r">{{
                              attr.extraMap && attr.extraMap.dealer.dealerName ? attr.extraMap.dealer.dealerName : ''
                            }}</span>
                          </span>
                        </span>
                      </div>
                    </div>
                    <div class="right">
                      <!-- <div style="marginRight:15px">
                        {{
                          attr.itemType === 1 || attr.itemType === '1' || attr.itemType === 2 || attr.itemType === '2'
                            ? attr.status === '5' ||
                              attr.status === '4' ||
                              attr.status === '3' ||
                              attr.status === 5 ||
                              attr.status === 4 ||
                              attr.status === 3
                              ? afterStatus[attr.status]
                              : ''
                            : afterStatus[attr.status]
                        }}
                      </div> -->
                      <!-- v-if="!attr.extraMap.bofogPurchase" -->
                      <div class="border-l">
                        <el-button
                          v-if="
                            (attr && attr.activityDetailMaps == null) ||
                            (attr && attr.activityDetailMaps && attr.activityDetailMaps[0].activityType !== 6)
                          "
                          @click="
                            toRefund(
                              attr.parentId ? attr.parentId : attr.orderId,
                              attr.orderContractId,
                              attr.id,
                              attr.itemType
                            )
                          "
                          class="btn"
                          :disabled="
                            [7, 8, 9, 10, -2].indexOf(attr.status) > -1 ||
                            ([2, 5].indexOf(attr.status) === -1 && attr.itemType === '1') ||
                            ([2, 5].indexOf(attr.status) === -1 && attr.itemType === '2') ||
                            ([2, 5].indexOf(attr.status) === -1 && attr.itemType === 1) ||
                            ([2, 5].indexOf(attr.status) === -1 && attr.itemType === 2)
                          "
                          >申请售后</el-button
                        >
                        <!-- <el-button @click="toRefund">申请退款</el-button> -->
                      </div>
                    </div>
                    <!-- <div class="img-con" :style="{ 'background-image': `url(${product.itemImage})` }"></div> -->

                    <!-- </p> -->
                    <!-- <p v-else class="des">
                      <span class="dealer"
                        >经销商:
                        {{
                          product.extraMap && product.extraMap.dealer ? product.extraMap.dealer.dealerName : ''
                        }}</span
                      >
                    </p> -->
                    <!-- <div class="border-b"></div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="orderList <= 0" class="no-data">
          <p class="note">暂无相关的售后记录</p>
        </div>
      </div>
      <div class="after-footer">
        <el-pagination
          layout="prev, pager, next"
          :total="orderCount"
          v-show="orderCount > orderListParams.pageSize"
          :pageSize="orderListParams.pageSize"
          :pageCount="orderListParams.pageSize"
          :currentPage="orderListParams.pageNo"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <div v-if="tabType == 1">
      <div class="after-content" v-loading="loading">
        <div class="infobox" v-for="(ulItem, ulIndex) in applyList" :key="ulIndex">
          <div class="header">
            <span class="time">下单时间: {{ ulItem.orderItem.createdAt }}</span>
            <span class="id"
              >订单编号:
              <span>{{ ulItem.orderItem.orderId }}</span>
            </span>
          </div>
          <!-- <div v-for="(liItem, liIndex) in ulItem.orderItem" :key="liIndex"> -->
          <div class="order">
            <div class="content">
              <div class="tips finish" v-if="ulItem.orderAftermarket.status == 4">已完成</div>
              <div :class="['tips', ulItem.orderAftermarket.status === -1 ? 'fail' : 'finish']" v-else>
                {{
                  stateTransition(
                    ulItem.orderAftermarket.status,
                    ulItem.orderAftermarket.type,
                    ulItem.orderItem.itemType
                  )
                }}
              </div>
              <div class="height">
                <div class="left">
                  <div class="img-container">
                    <img :src="ulItem.orderItem.itemImage" alt="" class="img-con" />
                  </div>
                  <div class="message">
                    <h3 class="tit">
                      <span
                        v-if="
                          ulItem.orderItem.extraMap &&
                          ulItem.orderItem.extraMap.activity &&
                          ulItem.orderItem.extraMap.activity.tag
                        "
                        class="activityTag"
                        >{{ ulItem.orderItem.extraMap.activity.tag }}</span
                      >
                      <span
                        v-if="ulItem.orderItem.extraMap && ulItem.orderItem.extraMap.bofogPurchase"
                        class="activityTag"
                        >赠品</span
                      >
                      <span v-if="ulItem.orderItem.extraMap && ulItem.orderItem.extraMap.collocationPurchase" class="activityTag"
                        >搭配购</span
                      >
                      <img
                        class="prizeTab"
                        style="width: 42px; height: 21px; margin: 0"
                        v-if="
                          (ulItem.orderItem.extraMap && ulItem.orderItem.extraMap.orderChannel === '3') ||
                          (ulItem.orderItem.extraMap && ulItem.orderItem.extraMap.orderChannel === 3)
                        "
                        src="@/assets/images/activity/lottery/prize.png"
                      />
                      {{ ulItem.orderItem.itemName }}
                      <span class="hide">
                        {{ ulItem.orderItem.skuName }}
                      </span>
                    </h3>
                    <div class="sku record">
                      <span
                        style="marginright: 10px"
                        v-for="(item, index) in ulItem.orderItem.attributeMaps"
                        :key="index"
                      >
                        {{ item.attrKey ? item.attrKey + ':' + item.attrVal : '' }}
                      </span>
                    </div>
                    <span class="number">
                      <span>
                        <span class="price">价格: {{ Number(ulItem.orderItem.skuPrice) | currency('￥', 2) }}</span>
                        <span>数量：x{{ ulItem.orderItem.quantity }}</span>
                      </span>
                    </span>
                    <span
                      class="dealerWrap"
                      v-if="ulItem.orderAftermarket.type == 0 || ulItem.orderAftermarket.type == 1"
                    >
                      <span v-for="(attrItem, attrIndex) in ulItem.orderItem.attributeMap" :key="attrIndex">
                        <span v-for="(attrItemValue, attrIndexKey) in attrItem.attributeMap" :key="attrIndexKey">
                          <span>{{ attrIndexKey }}:</span>
                          <span class="v-right">{{ attrItemValue }}</span>
                        </span>
                      </span>
                    </span>
                    <span
                      class="dealerWrap"
                      v-else-if="ulItem.orderAftermarket.type == 2 || ulItem.orderAftermarket.type == 3"
                    >
                      <span>经销商： </span>
                      <span class="attr-r">{{
                        ulItem.orderItem.extraMap && ulItem.orderItem.extraMap.dealer
                          ? ulItem.orderItem.extraMap.dealer.dealerName
                          : ''
                      }}</span>
                    </span>
                  </div>
                </div>
                <div class="right">
                  <div class="conright">
                    <p>服务单号：{{ ulItem.orderAftermarket.id }}</p>
                    <p>申请时间：{{ ulItem.orderAftermarket.createdAt }}</p>
                  </div>
                  <div class="border-le">
                    <div class="look">
                      <span @click="toAfterDetail(ulItem.orderAftermarket.id)" class="link">查看详情</span>
                    </div>
                  </div>
                </div>
                <!-- <div class="border-b"> -->
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
        <div v-if="applyList <= 0 && !loading" class="no-data">
          <p class="note">暂无相关的申请记录</p>
        </div>
      </div>
      <div class="after-footer">
        <el-pagination
          layout="prev, pager, next"
          :total="applyCount"
          v-show="applyCount > applyListParams.pageSize"
          :pageSize="applyListParams.pageSize"
          :pageCount="applyListParams.pageSize"
          :currentPage="applyListParams.pageNo"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import myorderApi from '@/api/myorder'
import moment from 'moment'
import afterApi from '@/api/aftersale'
/* eslint-disable */
export default {
  name: 'after-apply',
  components: {},
  data() {
    return {
      afterStatus: {
        0: '申请退款中',
        2: '小二审批成功',
        3: '财务审批成功',
        4: '退款成功',
        7: '退款失败',
        '-1': '退款关闭',
        5: '待买家发货',
        6: '待卖家收货',
        8: '财务审核'
      },
      tabType: 0,
      loading: false,
      orderList: [],
      orderListParams: {
        pageNo: 1,
        pageSize: 5,
        vmId: 1
        // status: 2
      },
      applyList: [],
      applyListParams: {
        pageNo: 1,
        pageSize: 5,
        vmId: 1
      },
      currentPage: 1,
      orderTotal: 0,
      applyTotal: 0
    }
  },
  computed: {
    applyCount() {
      let count = this.applyTotal
      if (!count) {
        count = 0
      }
      return count
    },
    orderCount() {
      let count = this.orderTotal
      if (!count) {
        count = 0
      }
      return count
    }
  },
  created() {
    this.getOrderList()
  },
  methods: {
    handleClick(tab, e) {
      // 点击切换选项卡
      this.tabType = tab.index
      if (tab.index === '0') {
        this.orderListParams.pageNo = 1
        this.getOrderList()
      } else {
        this.applyListParams.pageNo = 1
        this.getApplyList()
      }
    },
    // 获取售后申请列表
    getOrderList() {
      // this.orderListParams.statuses = '2,88,-2'
      // this.loading = true
      myorderApi.pagingOrderAftermarket(this.orderListParams).then(
        (res) => {
          if (res.status === 200 && res.data.data !== null) {
            this.orderList = res.data.data
            this.orderTotal = res.data.total
            // for (var i = 0; i < this.orderList.length; i++) {
            //   // 修改下单时间格式
            //   this.orderList[i].map((item) => {
            //     item.order.createdAt = moment(item.order.createdAt).format('YYYY.MM.DD HH:mm:ss')
            //   })
            // }

            this.orderList.map((item) => {
              item.orderContracts.map((elm) => {
                elm.orderItemDtoList.map((res) => {
                  res.createdAt = moment(res.createdAt).format('YYYY.MM.DD HH:mm:ss')
                })
              })
            })
            this.loading = false
          }
        },
        () => {
          this.loading = false
        }
      )
    },
    // 获取申请记录列表
    getApplyList() {
      // this.loading = true
      // this.applyListParams.statuses = '88,-2'
      afterApi.afterrecord(this.applyListParams).then(
        (res) => {
          if (res.status === 200 && res.data !== null) {
            const data = res.data.data
            this.applyTotal = res.data.total
            // for (var i = 0; i < data.length; i++) {
            //   // 修改时间格式
            //   // 订单时间
            //   data[i].orderItem.createdAt = moment(data[i].orderItem.createdAt).format('YYYY.MM.DD HH:mm:ss')
            //   // 申请时间
            //   data[i].orderAftermarket.createdAt = moment(data[i].orderAftermarket.createdAt).format(
            //     'YYYY.MM.DD HH:mm:ss'
            //   )
            //   if (~~data[i].orderItem.itemType === 8 && data[i].orderAftermarket.status === 2) {
            //     data[i].orderAftermarket.status = 6
            //   }
            // }
            data.map((item) => {
              // item.orderItems.map((res) => {
              //   res.createdAt = moment(res.createdAt).format('YYYY.MM.DD HH:mm:ss')
              // })
              item.orderItem.createdAt = moment(item.orderItem.createdAt).format('YYYY.MM.DD HH:mm:ss')
              item.orderAftermarket.createdAt = moment(item.orderAftermarket.createdAt).format('YYYY.MM.DD HH:mm:ss')
            })
            this.applyList = data
            this.loading = false
          }
        },
        () => {
          this.loading = false
        }
      )
    },
    // 分页器--根据点击页码进行跳转
    handleCurrentChange(val) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      if (Number(this.tabType) === 0) {
        this.orderListParams.pageNo = val
        this.getOrderList(2)
      } else if (Number(this.tabType) === 1) {
        this.applyListParams.pageNo = val
        this.getApplyList()
      }
    },
    // 跳转到申请退货
    toRefund(orderId, orderContractId, goodsId, itemType) {
      let query = {
        orderId: orderId,
        orderContractId: orderContractId,
        proId: goodsId,
        itemType: itemType
      }
      this.$router.push({ path: 'rejectSubmit', query: query })
    },
    // 跳转到退货详情页
    toAfterDetail(id) {
      let query = {
        afterId: id
      }
      this.$router.push({ path: 'afterDetail', query: query })
    },
    stateTransition(status, type, itemType) {
      let stateT
      stateT = {
        0: '提交申请',
        2: '申请审核',
        3: '进行退款',
        4: '处理完成',
        5: '申请审核',
        6: '售后收货',
        7: '退款失败',
        [-1]: '退款关闭'
      }
      // if (itemType === '8') {
      //   stateT = {
      //     0: '提交申请', // 提交申请
      //     6: '售后收货', // 申请审核
      //     2: type === 0 || type === '0' ? '进行退款' : '售后收货', // 售后收货
      //     3: '进行退款', // 进行退款
      //     4: '已完成', // 处理完成
      //     5: '提交申请',
      //     '-1': '退款关闭' // 审核不通过
      //   }
      // } else {
      //   stateT = {
      //     0: '提交申请', // 提交申请
      //     6: '申请审核', // 申请审核
      //     2: type === 0 || type === '0' ? '进行退款' : '售后收货', // 售后收货
      //     3: '进行退款', // 进行退款
      //     4: '已完成', // 处理完成
      //     5: '提交申请',
      //     '-1': '退款关闭' // 审核不通过
      //   }
      // }
      return stateT[status]
    }
  }
}
</script>
<style lang="scss" scoped>
.part-apply {
  width: 1025px;
  background: #fff;
  font-size: 18px;
  margin-bottom: 30px;
  .after-content {
    padding: 0 0 0 25px;
    position: relative;
    min-height: 536px;
    .infobox {
      margin-top: 20px;
      .border-b {
        width: 1025px;
        height: 2px;
        box-shadow: 0px 1px 0px 0px rgba(224, 224, 224, 1);
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        -o-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        bottom: 2px;
      }
      .header {
        font-size: 14px;
        height: 20px;
        line-height: 20px;
      }
      .time {
        color: #777;
        margin-right: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      .id {
        color: #b7b7b7;
        .hand {
          cursor: pointer;
        }
      }
    }
    .container {
      height: 195px;
      position: relative;
      .border-b {
        width: 1025px;
        height: 2px;
        box-shadow: 0px 1px 0px 0px rgba(224, 224, 224, 1);
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        -o-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
        bottom: 2px;
      }
      &:last-of-type {
        .border-b:last-of-type {
          visibility: hidden;
        }
      }
    }

    .order {
      font-size: 14px;

      .tips {
        float: right;
        background: url('../../assets/images/after/tip.png') no-repeat left center;
        background-size: 15px;
        color: #777;
        padding: 0 25px;
        position: absolute;
        top: 5px;
        right: 0;
      }
      .finish {
        background-image: url('../../assets/images/after/detailfinish.png');
        right: 46px;
      }
      .fail {
        background-image: url('../../assets/images/after/afterError.png');
        right: 46px;
      }
    }
    .content {
      padding: 15px 0 22px 0;
      font-size: 16px;
      color: #333;
      position: relative;
      border-bottom: 1px solid #e0e0e0;
      .img-container {
        margin-right: 14px;
        height: 143px;
        width: 202px;
        background-size: contain;
        background-repeat: no-repeat;
        float: left;
        .img-con {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .height {
        height: 143px;
        display: flex;
        justify-content: space-between;
      }
      .tit {
        padding: 16px 0 10px 0;
        font-size: 18px;
        height: 25px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 700;
        color: #333333;
        line-height: 25px;
        .hide {
          visibility: hidden;
        }
        .activityTag {
          padding: 0 3px;
          color: #fff;
          background: #df3d36;
          font-weight: 400;
          height: 21px;
          font-size: 16px;
          font-family: PingFangSC;
          font-weight: 500;
          line-height: 21px;
          margin-right: 5px;
        }
        .prizeTab {
          padding: 0 3px;
          height: 21px;
          vertical-align: middle;
          margin-right: 5px;
        }
      }
      .message {
        display: flex;
        flex-direction: column;
        .sku {
          margin-bottom: 8px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
        .record {
          height: 100%;
          max-width: 280px;
        }
        .number {
          margin-bottom: 8px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          .price {
            margin-right: 44px;
          }
        }
        .des {
          margin-top: 8px;
          .v-right {
            margin-right: 7px;
          }
        }
      }
      .right {
        display: flex;
        align-items: center;
        .border-l {
          width: 180px;
          padding: 0 30px;
          height: 60px;
          border-left: 2px solid #e0e0e0;
          text-align: center;
          // position: absolute;
          // right: 0;
          // top: 45px;
          .btn {
            height: 40px;
            border: 1px solid #cfcfcf;
            background-color: #fff;
            color: #666;
            cursor: pointer;
            margin-top: 10px;
            margin-right: 10px;
            outline: none;
            border-radius: 0;
            &:hover {
              border-color: #333;
              color: #333;
            }
            &:disabled {
              background-color: #dcdcdc;
              border-color: #dcdcdc;
              color: #fff;
              cursor: default;
            }
          }
        }
        .conright {
          // position: absolute;
          // top: 68px;
          // right: 40px;
          // margin-top: 53px;
          margin-right: 40px;
          p {
            margin-bottom: 10px;
            font-size: 14px;
            color: #666;
          }
        }
        .border-le {
          width: 166px;
          height: 60px;
          padding-left: 40px;
          padding-right: 8px;
          border-left: 2px solid #e0e0e0;
          text-align: center;
          // position: absolute;
          // right: 0;
          // top: 45px;
          .look {
            height: 60px;
            line-height: 60px;
            color: #666;
            .link {
              text-decoration-line: underline;
              &:hover {
                color: #333;
                cursor: pointer;
              }
              &:first-child {
                margin-right: 21px;
              }
            }
          }
        }
      }
    }
  }
  .after-footer {
    height: 32px;
    position: relative;
    margin: 40px auto 50px;
    background: #f9f9f9;
    padding-top: 50px;
    .el-pagination {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      -moz-transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      -o-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      .el-pager li.active {
        color: #fff;
        background-color: #333;
      }
      .number {
        height: 32px;
        width: 32px;
      }
      .el-pager li {
        padding: 0;
        border: 1px solid #dcdcdc;
        border-left: none;
        min-width: 32px;
        height: 32px;
        line-height: 32px;
      }
      button {
        height: 32px;
        width: 32px;
        padding: 0;
        min-width: 32px;
        border: 1px solid #dcdcdc;
        &:last-child {
          border-left: none;
        }
      }
    }
  }
  .no-data {
    height: 440px;
    background: url('../../assets/images/after/null.png') no-repeat center 70px;
    background-size: 264px;
    position: relative;
    .note {
      color: #777;
      font-size: 16px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      -moz-transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      -o-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      top: 60%;
    }
  }
}
</style>
